export const TestimonialsData = [
  {
    id: 1,
    text: 'The stay at the hotel was fantastic. The room was clean and comfortable, and the staff were friendly and helpful. I would definitely recommend this place.',
    author: 'John Doe',
    country: 'USA',
  },
  {
    id: 2,
    text: "I had an amazing experience at this hotel. The service was top-notch, and the amenities were great. I'll definitely be coming back on my next trip.",
    author: 'Jane Smith',
    country: 'Canada',
  },
  {
    id: 3,
    text: 'The hotel exceeded my expectations. The room was spacious and luxurious, and the location was perfect. I had a wonderful time during my stay.',
    author: 'Michael Johnson',
    country: 'UK',
  },
  {
    id: 4,
    text: "I couldn't have asked for a better stay. The hotel staff were attentive and made sure I had everything I needed. The ambiance was lovely, and I felt truly relaxed.",
    author: 'Sarah Davis',
    country: 'Australia',
  },
  {
    id: 5,
    text: 'I had a wonderful stay at the hotel. The room was immaculate, and the amenities were fantastic. The staff was warm and welcoming. Highly recommend!',
    author: 'Emily Anderson',
    country: 'France',
  },
  {
    id: 6,
    text: 'This hotel is a gem. The room was beautifully designed and had a great view. The service was exceptional, and I had a delightful experience during my stay.',
    author: 'David Thompson',
    country: 'Japan',
  },
  {
    id: 7,
    text: "My stay at this hotel was fantastic. The room was cozy and clean, and the staff went above and beyond to make my stay enjoyable. Can't wait to come back.",
    author: 'Olivia Harris',
    country: 'Brazil',
  },
  {
    id: 8,
    text: 'The hotel is a perfect blend of comfort and luxury. The staff was attentive, and the facilities were top-notch. I had a relaxing and enjoyable stay.',
    author: 'Matthew Turner',
    country: 'Germany',
  },
];
